import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lkd-navbar',
  templateUrl: './navbar.component.html',
  styles: []
})
export class NavbarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
